// Base
import { create } from "zustand";

// Types
import type { TemplateStore, TemplateState } from "@/types/types";

const initialState: TemplateState = {
  orderSummaryOpen: false,
  isLoading: false,
  sectionPositions: window?.post_template?.checkout_v7_section_positions,
  featuresSavings: window?.post_template?.checkout_v7_features_savings,
  colors: window?.post_template?.checkout_v7_colors,
  topBar: window?.post_template?.checkout_v7_topbar,
  productList: window?.post_template?.checkout_v7_product_list,
  customerAssurance: window?.post_template?.checkout_v7_customer_assurance,
  orderSummary: window?.post_template?.checkout_v7_order_summary,
  form: window?.post_template?.checkout_v7_form,
  footer: window?.post_template?.checkout_v7_footer,
  settings: window?.post_template?.checkout_v7_settings,
  isMobile: window.innerWidth <= 960,
  paymentMethod: "card",
  isApplePayAvailable: false,
  isGooglePayAvailable: false,
};

export const useTemplateStore = create<TemplateStore>((set) => ({
  ...initialState,
  setIsMobile: (payload: boolean) =>
    set((state) => ({ ...state, isMobile: payload })),
  toggleOrderSummary: () =>
    set((state) => ({ ...state, orderSummaryOpen: !state.orderSummaryOpen })),
  handlePaymentMethodChange: (payload: TemplateState["paymentMethod"]) =>
    set((state) => ({ ...state, paymentMethod: payload })),
  setLoadingState: (payload: boolean) =>
    set((state) => ({ ...state, isLoading: payload })),
  setIsApplePayAvailable: (val: boolean) =>
    set((state) => ({ ...state, isApplePayAvailable: val })),
  setIsGooglePayAvailable: (val: boolean) =>
    set((state) => ({ ...state, isGooglePayAvailable: val })),
  setPaymentAvailability: (applePay: boolean, googlePay: boolean) =>
    set((state) => ({
      ...state,
      isApplePayAvailable: applePay,
      isGooglePayAvailable: googlePay,
    })),
}));
